import { Injectable } from '@angular/core';
import config from 'src/app/config';
import { AbstractGuidedToursService } from './guided-tours.abstract.service';

declare let stonlyTrack: Function;

@Injectable({
  providedIn: 'root'
})

export class GuidedToursService implements AbstractGuidedToursService {

  constructor() { }

  public trackUser(id: string, isTrial: boolean, gender: number): void{
    stonlyTrack('identify', id, {
      'present_guided_tours': config.present_guided_tours,
      'is_trial': isTrial,
      'gender': gender
    });
  }

}
